/*! @azure/msal-common v5.2.0 2021-12-07 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-common";
var version = "5.2.0";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
